import React from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {arrayAlphabeticalSort} from "utils/helpers";
import {SelectField} from "./ZoneSubcompaniesSelect.style";

export const ZoneSubcompaniesSelect = ({
    value,
    onChange,
    disabled = false,
    mode = undefined,
    allowClear = false,
    showSearch = true,
    showTitle = true,
    showAllOption = false,
    marginBottom = "20px",
    placeholder = "",
    includeDeleted = false,
    optionFilter = () => true,
    initialCall = true,
    zoneId,
    ...props
}) => {
    const {t} = useTranslation();
    const stores = useStore();

    const [loading, zoneSubcompanies] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.operationOrganizationStore.listZoneSubcompanies.bind(null, {
            zoneId: zoneId
        }),
        dependencies: [zoneId],
        condition: !!zoneId,
        initialCall
    });

    return (
        <React.Fragment>
            {showTitle && <h5>{t("Bölge Alt Firmaları")}</h5>}
            <SelectField
                data-testid="zoneSubcompaniesSelect"
                value={value}
                onChange={onChange}
                disabled={disabled || loading}
                mode={mode}
                loading={loading}
                allowClear={allowClear}
                showSearch={showSearch}
                placeholder={placeholder || t("Alt firma seçiniz")}
                filterOption={(input, option) => {
                    return (
                        option?.["data-zonesubcompanyname"]
                            ?.toLocaleLowerCase("TR-tr")
                            ?.indexOf(input.toLocaleLowerCase("TR-tr")) >= 0 ||
                        option?.["data-zonesubcompanycompanyname"]
                            ?.toLocaleLowerCase("TR-tr")
                            ?.indexOf(input.toLocaleLowerCase("TR-tr")) >= 0
                    );
                }}
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="zoneSubcompaniesSelect_all_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {zoneSubcompanies?.items &&
                    zoneSubcompanies.items.length > 0 &&
                    arrayAlphabeticalSort([...zoneSubcompanies.items], "name")
                        .filter(optionFilter)
                        .map(zoneSubcompany => (
                            <SelectField.Option
                                key={zoneSubcompany._id}
                                value={zoneSubcompany._id}
                                data-testid="zoneSubcompaniesSelect_option"
                                style={{borderBottom: "1px solid #e0e0e0"}}
                                data-zonesubcompanyname={zoneSubcompany.name}
                                data-zonesubcompanycompanyname={zoneSubcompany.company?.companyName}
                            >
                                <div>{zoneSubcompany.name}</div>
                                <div style={{fontSize: "12px", color: "gray"}}>
                                    Firma : {zoneSubcompany.company?.companyName || "Bilinmiyor"}
                                </div>
                            </SelectField.Option>
                        ))}
            </SelectField>
        </React.Fragment>
    );
};
